import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import apiInstance from '../apis';

import modelSlice from './modelSlice';

const rootPersistConfig = {
  key: 'root',
  storage: storage,
  blacklist: ['api'],
};

const rootReducer = combineReducers({
  api: apiInstance.reducer,
  [modelSlice.name]: modelSlice.reducer,
});

export const persistedReducer = persistReducer(rootPersistConfig, rootReducer);

export type RootState = ReturnType<typeof persistedReducer>;
